export class Promotion {
  constructor(
    id,
    code,
    name,
    iconUrl,
    description,
    startAt,
    endAt,
    tags
  ) {
    this.id = id;
    this.code = code;
    this.name = name;
    this.iconUrl = iconUrl;
    this.description = description;
    this.startAt = startAt;
    this.endAt = endAt;
    this.tags = tags;
  }

  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new Promotion(
        input.id,
        input.code,
        input.name,
        input.icon_url,
        input.description,
        input.start_at,
        input.end_at,
        input.tags
      )
    }

    return new Promotion();
  }

  static fromApiArray(input) {
    if (input && Array.isArray(input)) {
      return input.map(item => Promotion.fromApiObject(item));
    }

    if (input && typeof (input) === "object") {
      return [Promotion.fromApiObject(input)];
    }

    return [];
  }
}